import React, { createContext, useContext, useRef, } from 'react';
export const FloatingContext = createContext(undefined);
export const FloatingContextProvider = ({ placement, children }) => {
    const triggerRef = useRef(null);
    const setRef = ref => {
        triggerRef.current = ref;
    };
    return (React.createElement(FloatingContext.Provider, { value: {
            placement,
            triggerRef,
            reference: setRef,
        } }, children));
};
export const useFloatingContext = () => {
    const context = useContext(FloatingContext);
    if (context === undefined) {
        throw new Error('useFloatingContext must be used within a FloatingProvider');
    }
    return context;
};
//# sourceMappingURL=FloatingContext.js.map